import React from "react";

const CustomSelect = ({ title, options = [], value = "", onChange, className, name }) => {
    return (
        <div className={`flex flex-col gap-1 ${className}`}>
            <select
                name={name}
                value={value || ""}
                onChange={onChange}
                className="border-2 border-gray-200 rounded-md w-full py-3 px-5 focus:outline-none focus:ring"
            >
                <option value="" disabled>
                    {title}
                </option>

                {options.map((option, index) => (
                    <option key={index} value={option}>
                        {option}
                    </option>
                ))}
            </select>
        </div>
    );
};

export default CustomSelect;
